export const sessionCookieName = 'SESSION';
export const sessionImpersonationCookieName = 'SESSION_IMPERSONATION';
export const sessionIdCookieName = 'SESSION_ID';

export const sessionConfig = {
    broadcastChannelName: 'w8shipping-session',
    idleTimeoutMinutes: Number(process.env.NEXT_PUBLIC_SESSION_IDLE_TIMEOUT_MINUTES) || 90,
    warningMinutes: Number(process.env.NEXT_PUBLIC_SESSION_WARNING_MINUTES) || 1,
};

export type SessionConfig = typeof sessionConfig;
